/**
 * Horario operativo del agente (auto-respuesta) — PURO, compartido api+web.
 *
 * El motor (`ai-engine`) lo consulta antes de responder; el panel lo usa para
 * el indicador "Disponible / Fuera de horario" con la MISMA lógica (nunca dos
 * implementaciones que puedan divergir).
 *
 * Convenciones:
 *  - `endHour` es EXCLUSIVO: una ventana 7–22 cubre de 07:00:00 a 21:59:59.
 *  - 0–24 = siempre activo.
 *  - Soporta ventanas que cruzan medianoche (p. ej. 22–6).
 */
/** Hora (0–23) del instante `now` en la zona `timezone`. */
export function hourInTimezone(now, timezone) {
    const formatted = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        hour12: false,
        timeZone: timezone,
    }).format(now);
    const n = Number(formatted);
    // Intl puede devolver "24" para la medianoche en algunos motores → normalizar a 0.
    return Number.isNaN(n) ? now.getHours() : n % 24;
}
/** ¿`now` cae dentro de la ventana operativa [startHour, endHour) en `timezone`? */
export function isWithinOperatingHours(now, timezone, startHour, endHour) {
    // Ventana completa: siempre activo (no hace falta calcular la hora).
    if (startHour <= 0 && endHour >= 24)
        return true;
    const h = hourInTimezone(now, timezone);
    if (startHour <= endHour)
        return h >= startHour && h < endHour;
    // Ventana que cruza la medianoche (p. ej. 22–6).
    return h >= startHour || h < endHour;
}
//# sourceMappingURL=operating-hours.js.map